  <div id="sidebar" class="nav-collapse sidebar">
    <div class="leftside-navigation">
      <div class="heading-title">My Account</div>
      <ul class="sidebar-menu right-side-accordion padd85">
        <li class="sub-menu">
          <a id="findADraftLink" class="" routerLink="/lobby">
            <i class="fa fa-trophy navIcon"></i> <span>Find a Draft</span>
          </a>
        </li>
        <li class="sub-menu">
          <a class="" [href]="siteURL+'/create-contest'"><i class="zmdi zmdi-gamepad"></i> <span>Create a Game</span>
          </a>
        </li>
        <li class="sub-menu">
          <a class="" routerLink="/rankings"
            ><i class="fas fa-sort-numeric-down navIcon"></i>
            <span>Rankings</span>
          </a>
        </li>
        <li class="sub-menu">
          <a class="" routerLink="/ownership/nfl"><i class="fas fa-user-circle"></i>
            <span>Player Exposures</span>
          </a>
        </li>
        <li class="sub-menu">
          <a [ngClass]="{'active':seletedMenu=='FindFriend'}" [href]="siteURL+'/'+user_name+'/friends'">
            <i class="zmdi zmdi-accounts zmdi-hc-fw navIcon"></i>
            <span>Find Friends</span>
          </a>
        </li>
        <li class="sub-menu">
          <a href="javascript:void(0)" (click)="openDialog(1)">
            <i class="fas fa-dollar-sign navIcon"></i> <span>Cashier</span>
          </a>
        </li>
        <li class="sub-menu">
          <a class="" routerLink="/messages">
            <i class="zmdi zmdi-comments zmdi-hc-fw navIcon"></i>
            <span>Messages</span>
          </a>
        </li>
        <li class="sub-menu">
          <a  [ngClass]="{'active':seletedMenu=='ReferAFriend'}" href="user/refer-friend">
            <i class="fa fa-sitemap navIcon"></i> <span>Refer a Friend</span>
          </a>
        </li>
      </ul>
      
    </div>
  </div>
  <div>

  
  <div class="copyright_text">
    <a
      href="https://twitter.com/DraftersFantasy"
      title="twitter"
      target="_blank"
      ><img
        [src]="assetURL+'/assets/default/images/twitter.png'"
        width="30"
        height="30"
        alt="twitter" /></a
    >&nbsp;&nbsp;
    <a
      href="https://www.facebook.com/DraftersFantasySports"
      target="_blank"
      title="facebook"
      ><img
      [src]="assetURL+'/assets/default/images/facebook.png'"
        width="30"
        height="30"
        alt="facebook" /></a
    >&nbsp;&nbsp;
    <a
      href="https://www.instagram.com/draftersfantasy/"
      target="_blank"
      title="Instagram"
      ><img
      [src]="assetURL+'/assets/default/images/instagram.png'"
        width="30"
        height="30"
        alt="Instagram"
    /></a>
    <div>
    Drafters,{{current_year}}<br>
    <a [href]="siteURL+'/rules'">Rules & Scoring</a>
    <br>
    <a [href]="siteURL+'/location-help'" title="location-help" target="_blank"
      >Location Help</a
    >
  </div>
  </div>
</div>